import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import { Close } from '@mui/icons-material';
import Editor from '@monaco-editor/react';
import { useTheme } from '@/hooks';
import { formatJsonWithNestedParsing } from '@/utils/jsonUtils';

interface NotificationPayloadDialogProps {
  open: boolean;
  onClose: () => void;
  payload: string | null;
}

const NotificationPayloadDialog: React.FC<NotificationPayloadDialogProps> = ({
  open,
  onClose,
  payload,
}) => {
  const { mode } = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: '80vh',
          maxHeight: '800px',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        Notification Payload
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="close"
          sx={{ color: 'text.secondary' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ height: '100%', p: 2 }}>
          <Box sx={{ height: '100%', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
          <Editor
            height="100%"
            language="json"
            value={formatJsonWithNestedParsing(payload)}
            theme={mode === 'dark' ? 'vs-dark' : 'light'}
            options={{
              readOnly: true,
              minimap: { enabled: false },
              scrollBeyondLastLine: false,
              fontSize: 14,
              wordWrap: 'on',
              automaticLayout: true,
            }}
          />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationPayloadDialog;
